import { Flex, TableContainer } from "@chakra-ui/react"
import React from "react"
import Header from "../../../components/Header"
import { Filtro } from "./components/Filtro/Filtro"
import { HeaderSimulacao } from "./components/Header"
import { Layout } from "./components/Layout"
import { ContainerGanhos } from "./components/Tabela/Ganhos"
import { Table } from "./components/Tabela/Table"
import { SimulacaoProdutoProvider } from "./contexts/SimulacaoProdutoContext"

const SimulacaoProduto = () => {
  return (
    <SimulacaoProdutoProvider>
      <Layout>
        <TableContainer scroll={{ x: "100%", y: "100%" }}>
          <Flex flexDirection={"column"} align="end">
            <HeaderSimulacao />
            <Filtro />
            <Flex gap={".1rem"}>
              <ContainerGanhos />
            </Flex>
          </Flex>
          <Table />
        </TableContainer>
      </Layout>
    </SimulacaoProdutoProvider>
  )
}

export default SimulacaoProduto
